import "core-js/modules/es.object.keys.js";
export default {
  name: 'importFailProduct',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    importObj: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      advanced: false,
      modelcolumns: [{
        title: this.$t('publicuse.goodsno'),
        dataIndex: 'goodsNo',
        key: 'goodsNo',
        width: '10%'
      }, {
        dataIndex: 'goodsName',
        key: 'goodsName',
        width: '36%',
        slots: {
          title: 'goodsnametitle' //自定义标头
        },
        scopedSlots: {
          customRender: 'goodsname' //自定义表格里面的内容
        },
        ellipsis: true
      }, {
        title: this.$t('public.failurereason'),
        dataIndex: 'productStatus',
        key: 'productStatus',
        width: '10%',
        scopedSlots: {
          customRender: 'statename' //自定义表格里面的内容
        }
      }, {
        title: this.$t('publicuse.pricetax'),
        dataIndex: 'price',
        key: 'price',
        width: '14%',
        className: 'column-pricetax',
        scopedSlots: {
          customRender: 'pricetax'
        }
      }, {
        title: this.$t('publicuse.stock'),
        dataIndex: 'productStockNum',
        key: 'productStockNum',
        width: '10%',
        scopedSlots: {
          customRender: 'product-stocknum'
        }
      }]
    };
  },
  watch: {},
  created: function created() {},
  methods: {
    cancelmodal: function cancelmodal(e) {
      this.$emit("get-visible", false);
    },
    resetFormDate: function resetFormDate() {
      console.log(123123);
      this.$emit("get-visible", false);
    }
  }
};